// web/app/themes/venti/assets/src/js/blocks/box-slider.js

export default function initializeBoxSlider() {
    document.querySelectorAll('.box-slider').forEach(function (block) {
        if (block.querySelector('.box-slider__swiper')) {
            new BoxSlider(block);
        }
    });
}

class BoxSlider {
    constructor(block) {
        this.block = block;
        this.init();
    }

    getOffsetValue(breakpoint) {
        // ЗАЛИШЕНО для сумісності, але не використовується (офсети прибрані)
        var containerWidth = 0;

        switch (breakpoint) {
            case 0:
                containerWidth = document.body.clientWidth;
                break;
            case 576:
                containerWidth = 540;
                break;
            case 768:
                containerWidth = 720;
                break;
            case 992:
                containerWidth = 960;
                break;
            case 1200:
                containerWidth = 1140;
                break;
            case 1400:
                containerWidth = 1320;
                break;
            case 1800:
                containerWidth = 1744;
                break;
            default:
                containerWidth = document.body.clientWidth;
                break;
        }

        return (document.body.clientWidth - containerWidth) / 2;
    }

    init() {
        var self = this;

        import('swiper/bundle').then(function (mod) {
            var Swiper = mod.default;

            var timer = null;

            window.addEventListener('resize', function () {
                if (timer) {
                    clearTimeout(timer);
                }
                // ВАЖЛИВО: передаємо функцію, а не результат виклику
                timer = setTimeout(function () {
                    self.initSwiper(Swiper);
                }, 100);
            });

            self.initSwiper(Swiper);
        });
    }

    initSwiper(Swiper) {
        var sliders = this.block.querySelectorAll('.box-slider__swiper');

        for (var i = 0; i < sliders.length; i++) {
            var slider = sliders[i];

            // Якщо вже є інстанс — знищуємо перед ре-інітом
            if (slider.swiper && typeof slider.swiper.destroy === 'function') {
                slider.swiper.destroy(true, true);
            }

            var pagination = this.block.querySelector('.swiper-pagination');
            var scrollbar = this.block.querySelector('.swiper-scrollbar');
            var itemsAttr = slider.getAttribute('data-items');
            var sliderPerView = itemsAttr ? itemsAttr : 'auto';

            var config = {
                speed: 500,
                loop: false,
                spaceBetween: 0,
                slidesPerView: (sliderPerView === 'auto') ? 'auto' : parseInt(sliderPerView, 10),
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: true
                },
                scrollbar: {
                    el: scrollbar
                },
                navigation: {
                    nextEl: this.block.querySelector('.box-slider__arrow--next'),
                    prevEl: this.block.querySelector('.box-slider__arrow--prev')
                },
                pagination: {
                    el: pagination,
                    clickable: true
                },
                // ГОЛОВНЕ: офсети прибрано (0), щоб не було небажаного зсуву
                breakpoints: {
                    0: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                    768: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        slidesPerView: 'auto'
                    },
                    992: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                    1200: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                    1400: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    },
                    1800: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    }
                }
            };

            var swiper = new Swiper(slider, config);

            // Стартуємо autoplay лише коли слайдер у в’юпорті
            if (swiper && swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
                swiper.autoplay.stop();
            }

            // IntersectionObserver без optional chaining для сумісності зі старішим Babel
            var observer = new IntersectionObserver(function (entries, ob) {
                if (entries && entries[0] && entries[0].isIntersecting) {
                    setTimeout(function () {
                        ob.disconnect();
                        if (swiper && swiper.autoplay && typeof swiper.autoplay.start === 'function') {
                            swiper.autoplay.start();
                        }
                    }, 100);
                }
            });

            observer.observe(slider);
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    var section = document.getElementById('venti-top-category-slider-loader');
    if (!section) return;

    var hasLoaded = false;

    function loadSliderAjax() {
        if (hasLoaded) return;
        hasLoaded = true;

        var productId = section.dataset.productId;
        var nonce     = section.dataset.nonce;
        var ajaxUrl   = section.dataset.ajaxUrl;

        var formData = new FormData();
        formData.append('action', 'venti_load_top_category_slider');
        formData.append('product_id', productId);
        formData.append('nonce', nonce);

        fetch(ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        })
            .then(function(res){ return res.json(); })
            .then(function(res){
                if (!res || !res.success) {
                    section.innerHTML = '';
                    return;
                }

                section.innerHTML = res.data.html;
                initializeBoxSlider(section); // тільки в цьому блоці
            })
            .catch(function(){
                section.innerHTML = '';
            });
    }

    // Lazy-load по перетину
    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries, ob) {
            if (entries[0].isIntersecting) {
                ob.disconnect();
                loadSliderAjax();
            }
        }, { rootMargin: '200px 0px' }); // трошки раніше

        observer.observe(section);
    } else {
        // Старі браузери — просто грузимо одразу
        loadSliderAjax();
    }
});